import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const operatePrivateCloudRouterInterface = (data, id) => {
  data.router_id = id
  return axios.request({
    url: `${privateCloudBaseUrl}router_interface_operate/`,
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'post'
  })
}
